module.exports = __webpack_public_path__ + "img/bg_table_top.141d2ce0.png";